import React from 'react';
import InfiniteScroll from 'v2/common/InfiniteScroll/InfiniteScroll';
import LoadingSpinner from 'v2/common/LoadingSpinner/LoadingSpinner';
import { useInfiniteStrapiUsers } from 'v2/queries';
import BuyerMembersList from './BuyerMembersList/BuyerMembersList';

export function MembersTab() {
  const { data, isLoading, fetchNextPage, isFetching, hasNextPage } =
    useInfiniteStrapiUsers();

  const members = data?.pages.flatMap((page) => page.results) || [];

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <BuyerMembersList members={members} />
      <InfiniteScroll
        callback={fetchNextPage}
        isLoading={isFetching}
        disabled={!hasNextPage}
        scrollThreshold={500}
      />
    </>
  );
}
